var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店铺名称" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品展示名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.activityName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "activityName", $$v)
                      },
                      expression: "searchInfo.activityName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.activityStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityStatus", $$v)
                        },
                        expression: "searchInfo.activityStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "启用", value: 1 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "禁用", value: 2 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.onAdd }
                    },
                    [_vm._v("添加兑换商品")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "店铺名称", prop: "sellerId", width: "180px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "商品展示名称", prop: "activityName" }
          }),
          _c("el-table-column", {
            attrs: { label: "所需牛币", prop: "onePrice" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.activityRuleList
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.activityRuleList[0].onePrice) +
                              "牛币 "
                          ),
                          scope.row.activityRuleList[0].extraAddMoney > 0
                            ? [
                                _vm._v(
                                  "    +   " +
                                    _vm._s(
                                      scope.row.activityRuleList[0]
                                        .extraAddMoney
                                    ) +
                                    "元"
                                )
                              ]
                            : _vm._e()
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _c("el-table-column", {
            attrs: { label: "自定义条码", prop: "goodsNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "activityStatus", width: "80px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.activityStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    scope.row.activityStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onAble(scope.row)
                          }
                        }
                      },
                      [_vm._v("启用")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onDisable(scope.row)
                          }
                        }
                      },
                      [_vm._v("禁用")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewPointGoodsDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewPointGoodsDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "店铺名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sellerName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sellerName", $$v)
                              },
                              expression: "formData.sellerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品展示名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "自定义条码：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.goodsNo,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "goodsNo", $$v)
                              },
                              expression: "formData.goodsNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "所需牛币：" } },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.onePrice,
                                callback: function($$v) {
                                  _vm.$set(item, "onePrice", $$v)
                                },
                                expression: "item.onePrice"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("牛币")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c("el-form-item", { attrs: { label: "商品原价：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.goodsComponentFormData.activityGoodsMoney
                              ) +
                              "元 "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "兑换商品：", prop: "isAllGoods" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.activityGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "商品数量", prop: "goodsNum" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addPointGoodsDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addPointGoodsDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "onePriceFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择店铺：", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled:
                                  _vm.formData.activityNo &&
                                  _vm.formData.activityNo != ""
                              },
                              on: { change: _vm.onSellerChange },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.sellerOptions, function(item) {
                              return _c("el-option", {
                                key: item.sellerId,
                                attrs: {
                                  label: item.sellerName,
                                  value: item.sellerId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "兑换商品：", prop: "isAllGoods" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", icon: "el-icon-add" },
                              on: {
                                click: function($event) {
                                  return _vm.onAddGoods("pointGoods")
                                }
                              }
                            },
                            [_vm._v("添加商品")]
                          ),
                          _c("br"),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.activityGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark",
                                height: "18rem"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "商品数量",
                                  prop: "goodsNum",
                                  width: "150"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          staticClass: "bairun-input-fill",
                                          staticStyle: { height: "47px" },
                                          attrs: {
                                            min: 1,
                                            placeholder: "商品数量",
                                            "controls-position": "right"
                                          },
                                          on: { change: _vm.computeGoodsPrice },
                                          model: {
                                            value: scope.row.goodsNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "goodsNum",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.goodsNum"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "60px" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-close",
                                            size: "mini",
                                            circle: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onDelActivityGoods(
                                                scope.row
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "所需牛币：",
                              prop: "activityRuleList." + index + ".onePrice",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 1
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.onePrice,
                                callback: function($$v) {
                                  _vm.$set(item, "onePrice", $$v)
                                },
                                expression: "item.onePrice"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("牛币")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c("el-form-item", { attrs: { label: "商品原价：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.goodsComponentFormData.activityGoodsMoney
                              ) +
                              "元 "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品展示名称：",
                            prop: "activityName"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "自定义条码：", prop: "goodsNo" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.goodsNo,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "goodsNo", $$v)
                              },
                              expression: "formData.goodsNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.goodsComponentFormData.dialogVisible
        ? _c("GoodsSelectComponent", {
            ref: "GoodsSelectComponent",
            attrs: { "goods-component-form-data": _vm.goodsComponentFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }